import { useMemo } from "react";
import IconListDropdown, { Option } from "./IconListDropdown";
import CompanyService from "../services/CompanyService";

export default function TagsIconDropdown({
  title = "Etiquetas",
  value,
  onChange
}: {
  title?: string;
  value?: Array<string | number>;
  onChange: (val: Array<string | number>) => void;
}) {
  const options: Option[] = useMemo(() => {
    const tags = CompanyService.getTags() ?? [];
    return tags.map((t: any) => ({
      value: t.Id ?? t.id ?? t.value ?? t.Value,
      label: t.Value ?? t.label ?? t.name ?? String(t.Id ?? t.value)
    }));
  }, []);

  const hasSelection = Array.isArray(value) && value.length > 0;

  return (
    <IconListDropdown
      title={title}
      iconClass={`far fa-tags ${hasSelection ? "text-primary" : "text-muted"}`}
      options={options}
      multiple
      value={value}
      onChange={onChange}
    />
  );
}
